"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeChangesWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var HomeUtils_1 = require("./HomeUtils");
var AnnualHomeChangesWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeChangesWidget, _super);
    function AnnualHomeChangesWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.homeUtils = new HomeUtils_1.HomeUtils();
        _this.state = {
            oldInteraction: {},
            dataLoaded: false,
        };
        return _this;
    }
    AnnualHomeChangesWidget.prototype.componentDidMount = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        if (interaction.process === services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL) {
            this.customerPortalService.getRenewalProposal(this.props.engine.getInteraction().agreementNumber).subscribe(function (renewalProposal) {
                if (renewalProposal) {
                    _this.setState({
                        oldInteraction: renewalProposal,
                        dataLoaded: true
                    });
                }
            });
        }
        else {
            this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
                _this.setState({
                    oldInteraction: policy.interaction,
                    dataLoaded: true
                });
            });
        }
    };
    AnnualHomeChangesWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        if (this.state.dataLoaded) {
            if (interaction.factors && this.state.oldInteraction.factors) {
                return this.homeUtils.getChangesMade(interaction, this.state.oldInteraction);
            }
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualHomeChangesWidget.prototype, "customerPortalService", void 0);
    return AnnualHomeChangesWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeChangesWidget = AnnualHomeChangesWidget;
//# sourceMappingURL=AnnualHomeChangesWidget.js.map